export default {
  scope: ({ site, path }) => site.includes('fleetwood') || path.includes('fleetwood'),
  colors: { brand: '#0018a8' },
  fonts: { 
    heading: 'Oswald Regular, sans-serif',
    displaySmall: 'Roboto Fleetwood, sans-serif',
    body: 'Roboto Fleetwood, sans-serif',
  },
  icons: { tools: { textColor: 'BrandFleetwood' } }
};
